module.exports = __webpack_public_path__ + "static/media/Mama Rochel - Parent Handbook.b6d7d8ac.pdf";